import React from 'react';
import { Info } from 'lucide-react';

export const AiEstimateNotice = ({ className = '' }) => (
  <p
    data-testid="ai-estimate-notice"
    className={`text-xs text-muted-foreground italic flex items-center gap-1 ${className}`}
  >
    <Info className="w-3 h-3 flex-shrink-0" />
    AI estimate — not medical advice
  </p>
);
